import { render, staticRenderFns } from "./DropdownList.vue?vue&type=template&id=ff9267d0&scoped=true&"
import script from "./DropdownList.vue?vue&type=script&lang=ts&"
export * from "./DropdownList.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownList.less?vue&type=style&index=0&id=ff9267d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9267d0",
  null
  
)

export default component.exports